export const googleApi = () => {
  return new Promise((resolve, reject) => {
    const googleMeta = document.createElement("meta");
    document.head.appendChild(googleMeta);
    googleMeta.setAttribute("name", "google-signin-client_id");
    googleMeta.setAttribute("content", process.env.VUE_APP_API_BACKEND);
    googleMeta.setAttribute("name", "google-signin-scope");
    googleMeta.setAttribute("content", "profile email");
    const googleScript1 = document.createElement("script");

    googleScript1.setAttribute("src", "https://apis.google.com/js/platform.js");
    googleScript1.onload = () => {
      window.gapi.load("auth2", () => {
        window.gapi.auth2
          .init({
            client_id: process.env.VUE_APP_ID_CLIENTE_LOGIN_GOOGLE,
            cookiepolicy: "single_host_origin",
          })
          .then((e) => {
            return resolve(e);
          })
          .catch((e) => {
            reject(e);
          });
      });
    };
    document.head.appendChild(googleScript1);
  });
};
